<template>
  <div class="row">
    <gcicPopup v-if="showPopup" v-on:close="showPopup = false" />
    <img src="../assets/gcicLogo.png" class="gcic-logo" />
    <div class="col-md-10 col-md-offset-1">
      <p>Please edit or complete the following fields.</p>
      <small><i>*required</i></small>
      <hr />
      <div class="row">
        <div class="form-group col-md-6">
          <div class="form-group input-group">
            <span style="background: white;" class="input-group-addon"
              ><span>Name*</span></span
            >
            <input
              class="form-control"
              :value="$store.getters.getEditedProviderValueByKeyChain(['name'])"
              @input="setName"
              type="username"
              placeholder="Provider Name"
              required
            />
          </div>
        </div>

        <div class="form-group col-md-6">
          <div class="form-group input-group">
            <span style="background: white;" class="input-group-addon"
              ><span>Year Founded*</span></span
            >
            <select
              style="margin: 0px; border-top-left-radius: 0px;"
              class="form-control"
              :value="
                $store.getters.getEditedProviderValueByKeyChain([
                  'year_founded'
                ])
              "
              @input="setDate"
              required
            >
              <option :value="null">Select year</option>
              <option v-for="year in yearRange">{{ year }}</option>
            </select>
          </div>
        </div>
        <div class="form-group col-md-12">
          <div class="form-group input-group">
            <span style="background: white;" class="input-group-addon"
              ><span>URL*</span></span
            >
            <input
              class="form-control"
              :value="$store.getters.getEditedProviderValueByKeyChain(['url'])"
              @input="setUrl"
              type="url"
              oninvalid="setCustomValidity('Enter a valid URL beginning with http or https.')"
              placeholder="https://example.com"
              required
            />
          </div>
        </div>

        <div class="form-group col-md-12">
          <span>Description*</span>
          <small><i>(200 - 1000 characters)</i></small>
          <div class="form-group input-group" style="width: 100%;">
            <textarea
              style="border-radius: 5px;"
              class="form-control"
              :value="
                $store.getters.getEditedProviderValueByKeyChain(['description'])
              "
              @input="setDesc"
              type="text"
              rows="7"
              maxlength="10000"
              minlength="200"
              required
            />
          </div>
        </div>

        <div class="form-group col-md-6">
          <div class="form-group input-group">
            <span style="background: white;" class="input-group-addon"
              ><span>Email</span></span
            >
            <input
              class="form-control"
              :value="
                $store.getters.getEditedProviderValueByKeyChain(['email'])
              "
              @input="setEmail"
              type="email"
              placeholder="Email Address"
            />
          </div>
        </div>

        <div class="form-group col-md-6">
          <div class="form-group input-group">
            <span style="background: white;" class="input-group-addon"
              ><span>Phone Number</span></span
            >
            <input
              class="form-control"
              :value="
                $store.getters.getEditedProviderValueByKeyChain([
                  'phone_number'
                ])
              "
              @input="setPhoneNumber"
              type="tel"
              pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
              placeholder="Phone Number"
            />
          </div>
        </div>

        <div class="col-md-12">
          <img
            height="100px"
            style="margin-bottom: 4px;"
            :v-if="$store.getters.getEditedProviderValueByKeyChain(['logo'])"
            :src="$store.getters.getEditedProviderValueByKeyChain(['logo'])"
          />
          <filestack :apikey="apikey" :options="options" @success="onSuccess">
            <button class="btn btn-create">
              Upload logo
            </button>
          </filestack>
        </div>
      </div>

      <hr style="margin-top: 20px; margin-bottom: 20px;" />

      <form v-on:submit.prevent>
        <contacts />
      </form>

      <hr style="margin-top: 20px; margin-bottom: 20px;" />
      <h4>Deals</h4>
      <p>Please add any deals you have been involved in.</p>
      <div>
        <button
          class="btn-default btn-create"
          style="margin-top: 0px; margin-left: 0px;"
          type="button"
          @click="createNewDeal"
        >
          Create new deal
        </button>
        <div v-for="(deal, index) in deals">
          <hr style="margin-top:20px;" />
          <inputForm :key="index" :index="index" />
        </div>
      </div>

      <hr style="margin-top: 20px; margin-bottom: 20px;" />
      <h4>Key Facts</h4>
      <p>Please fill out the fields below about your investment approach.</p>

      <div class="row">
        <form v-on:submit.prevent>
          <div class="col-md-12">
            <keyStats
              :show="[
                'minimumInvestment',
                'maximumInvestment',
                'avgAmountRaised',
                'femaleFocus'
              ]"
            />
          </div>
          <div class="col-md-12">
            <keyDescs :show="['applicationProcess']" />
          </div>
        </form>
      </div>
      <form v-on:submit.prevent="submit">
        <saveButton />
      </form>
    </div>
  </div>
</template>

<script>
import dealInputForm from "../elements/dealInputForm.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import contacts from "../elements/contacts.vue";
import Filestack, { client } from "filestack-vue";
import textInput from "../elements/textInput.vue";
import buttons from "../elements/buttons.vue";
import keyStats from "../elements/stats.vue";
import keyDescs from "../elements/descs.vue";
import utils from "./utils.js";
import saveButton from "../elements/saveButton.vue";
import gcicPopup from "../elements/gcicPopup.vue";

export default {
  name: "gcic-page",
  data: function() {
    return {
      apikey: "AfgNVUvKyT1uyldNwIASmz",
      options: {},
      showPopup: true
    };
  },
  components: {
    textInput: textInput,
    buttons: buttons,
    filestack: Filestack,
    inputForm: dealInputForm,
    keyStats: keyStats,
    keyDescs: keyDescs,
    contacts: contacts,
    saveButton: saveButton,
    gcicPopup: gcicPopup
  },
  computed: {
    ...mapGetters({
      editedProvider: "getEditedProviderValueByKeyChain",
      isCreateMode: "isCreateMode",
      verifySync: "verifySync",
      noErrors: "noErrors",
      next: "next",
      prev: "prev"
    }),
    deals: function() {
      return this.editedProvider(["relationships"]);
    },
    yearRange: function() {
      return utils.yearRange();
    }
  },
  methods: {
    ...mapMutations({
      deleteProviderProperty: "deleteEditedProviderPropertyByKeyChain"
    }),
    onSuccess(event) {
      this.setLogo(event.filesUploaded[0].url);
    },
    submit: function() {
      utils.post(this);
    },
    setName(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["name"]
      });
    },
    setEmail(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["email"]
      });
    },
    setPhoneNumber(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["phone_number"]
      });
    },
    setDesc(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["description"]
      });
    },
    setUrl(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["url"]
      });
    },
    setLogo(event) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: event,
        keyChain: ["logo"]
      });
    },
    setDate(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["year_founded"]
      });
    },
    createNewDeal: function() {
      this.$store.commit("createNewProviderProperty", "relationships");
    },
    submit: function() {
      utils.post(this);
    }
  },
  beforeRouteLeave: function(to, from, next) {
    var self = this;
    utils.beforeRouteLeave(self, to, from, next);
  }
};
</script>

<style scoped>
.gcic-logo {
  display: block;
  height: 82px;
  margin: auto;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
}

.bottom-container {
  position: fixed;
  left: 0;
  bottom: 0px;
  width: 100%;
  color: white;
  text-align: center;
  z-index: 9999;
}

.nav-button {
  display: inline-block;
  padding: 5px 15px 5px 15px;
  margin-left: 13px;
  margin-right: 13px;
  border: solid 2px black;
  border-radius: 10px;
  background-color: white;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
}

.nav-button:hover {
  background-color: grey;
}

.left-button {
  float: left;
}

.right-button {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/gcicPage.vue